import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import './NotFound.css';

// Puzzled robot drawn in brand colours; all motion is CSS (see NotFound.css)
const SearchingRobot = () => (
  <svg className="nf-robot" viewBox="0 0 240 240" aria-hidden="true">
    <ellipse className="nf-shadow" cx="112" cy="224" rx="46" ry="7" />
    <g className="nf-bot">
      <text className="nf-question" x="168" y="46">?</text>

      {/* Antenna */}
      <line x1="112" y1="44" x2="112" y2="24" stroke="#8FB2EE" strokeWidth="4" strokeLinecap="round" />
      <circle className="nf-antenna-light" cx="112" cy="18" r="7" />

      {/* Head */}
      <rect x="58" y="44" width="108" height="76" rx="20" fill="#0E1A34" />
      <rect x="48" y="70" width="10" height="26" rx="4" fill="#3E6AF6" />
      <rect x="166" y="70" width="10" height="26" rx="4" fill="#3E6AF6" />
      <rect x="70" y="56" width="84" height="50" rx="14" fill="#1C2C52" />
      <g className="nf-eyes">
        <g className="nf-eye-blink">
          <circle cx="94" cy="81" r="8" fill="#65D0EB" />
          <circle cx="130" cy="81" r="8" fill="#65D0EB" />
        </g>
      </g>

      {/* Neck + body */}
      <rect x="100" y="120" width="24" height="10" rx="3" fill="#8FB2EE" />
      <rect x="70" y="130" width="84" height="66" rx="16" fill="#3E6AF6" />
      <rect x="88" y="146" width="48" height="24" rx="8" fill="#0E1A34" />
      <circle className="nf-led nf-led-1" cx="100" cy="158" r="4" />
      <circle className="nf-led nf-led-2" cx="112" cy="158" r="4" />
      <circle className="nf-led nf-led-3" cx="124" cy="158" r="4" />

      {/* Arms */}
      <rect x="52" y="138" width="14" height="44" rx="7" fill="#8FB2EE" />
      <rect x="158" y="138" width="14" height="44" rx="7" fill="#8FB2EE" />

      {/* Feet */}
      <rect x="82" y="196" width="22" height="14" rx="6" fill="#8FB2EE" />
      <rect x="120" y="196" width="22" height="14" rx="6" fill="#8FB2EE" />
    </g>
  </svg>
);

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <section className="not-found">
      <SEO title={t('notFound.title')} noindex />
      <div className="container not-found-inner">
        <SearchingRobot />
        <div className="not-found-text">
          <p className="nf-code">404</p>
          <h1>{t('notFound.title')}</h1>
          <p>{t('notFound.text')}</p>
          <p className="nf-hint">{t('notFound.hint')}</p>
          <div className="nf-actions">
            <Link to="/" className="btn btn-primary">{t('notFound.home')}</Link>
            <Link to="/contact" className="btn nf-secondary">{t('notFound.contact')}</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
